<template>
    <div class="region-chooser" :class="{ 'single-width': onlySelected }">
        <div
            class="tile"
            v-for="region in displayRegions"
            :key="region.region_code"
            :data-value="region.region_code"
            :class="{
                selected: value === region.region_code && !onlySelected,
                disabled: disabled
            }"
            @click="selectRegion(region.region_code)"
        >
            <div class="flag">
                <img :src="require(`@/assets/images/flags/${region.region_code}.svg`)">
            </div>
            <div>{{ region.name }}</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'RegionChooser',
        props: {
            value: {
                type: String,
                default: null
            },
            disabled: {
                type: Boolean,
                default: false
            },
            onlySelected: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                regions: []
            };
        },
        computed: {
            displayRegions() {
                if (this.onlySelected) {
                    return this.regions.filter(region => this.value === region.region_code);
                }
                return this.regions;
            }
        },
        methods: {
            selectRegion(regionCode) {
                if (this.disabled) return;
                this.$emit('input', regionCode);
                this.$emit('change', regionCode);
            }
        },
        async mounted() {
            this.regions = await this.$api.get('d/regions');
        }
    }
</script>

<style lang="scss" scoped>
    .region-chooser {
        overflow-y: auto;
        max-height: 290px;
        max-width: 300px;
        min-width: 280px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        &.single-width {
            max-width: 144px;
            min-width: 134px;

            .tile {
                width: 100%;
            }
        }

        .tile {
            cursor: pointer;
            @include border;
            border-radius: 3px;
            user-select: none;
            display: flex;
            flex-direction: column;
            height: 135px;
            width: calc(50% - 6px);
            margin: 12px 0 0 12px;

            &:nth-child(odd) {
                margin-left: 0;
            }

            &:first-child, &:nth-child(2) {
                margin-top: 0;
            }

            &.selected {
                border-color: $color-main;
                background-color: $color-select;

                .flag {
                    border-color: $color-main;
                }
            }

            &.disabled {
                cursor: not-allowed;

                &:not(.selected) {
                    background-color: $color-disabled-bg;
                }
            }

            .flag {
                flex-grow: 1;
                border-bottom: 1px solid $color-border;
                display: flex;
                align-items: center;
                justify-content: center;

                img {
                    height: 40px;
                }
            }

            > div:last-child {
                padding: 1em 0.5em;
                text-align: center;
                font-weight: $bold;
                font-size: 0.9em;
            }
        }
    }
</style>